import { h, Fragment, Component } from "preact";
import { useMemo } from 'preact/hooks'
import { observer } from "mobx-react";

import {
  Banner,
//  Results as ResultsComponent,
  withStore,
  withController,
} from "@searchspring/snap-preact-components";

import { DesktopFilterSummary } from "../FilterSummary/DesktopFilterSummary";
import { FeaturedFilter } from "../FilterSummary/FeaturedFilter";
import { ProductCount } from '../FilterSummary/ProductCount';
import { Profile } from "../Profile/Profile";
import { ResultsComponent } from './ResultsComponent';
import { SidebarContents } from "../Sidebar/Sidebar";
import { Toolbar } from "../Toolbar/Toolbar";
import { MediaQuery } from '../Helpers/MediaQuery';

import { getContext } from "@searchspring/snap-toolbox";


import "./results.css";

@withStore
@withController
@observer
export class Results extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector(".search-results-template-wrapper");
    if(templateWrapper) {
      templateWrapper.style = "display: unset";
    }

    const { merchandising, results, pagination } = this.props.store;
    const controller = this.props.controller;
    let variantRedirectParam = '';
    try {
      results.forEach(result => {
        const core = result?.mappings?.core;
        const variantID = result?.attributes?.variant_id ? result?.attributes?.variant_id : '';
        const variantIDArray = variantID.includes('|') ? variantID.split('|') : [variantID];
        const sku = result?.attributes?.variant_sku ? result?.attributes?.variant_sku : '';
        const variantSkus = sku.findIndex ? sku : sku.split('|');
        const searchTerm = controller?.store?.search?.query?.string;
        
        if(variantSkus.length > 1 && variantIDArray.length > 1 && searchTerm) {
            const variantIndex = variantSkus.findIndex(variantSku => searchTerm.includes(variantSku));
            if(variantIndex != -1 && variantIDArray[variantIndex] != undefined) {
                variantRedirectParam = `?variant=${variantIDArray[variantIndex]}`;
                window.location.replace(`${core.url}${variantRedirectParam}`);
                this.setState({isRedirecting: true})
                return;
            }
        } else if(sku.length > 0 && searchTerm?.includes(sku)) {
          window.location.replace(core.url);
          variantRedirectParam = core.url
          this.setState({isRedirecting: true})
          return;
        }
      });

    } catch(e) {
      console.error("Searchspring settings have changed. Not receiving required fields variant_id and variant_sku");
    }

    if (templateWrapper) {
      templateWrapper.classList.add("some-results");
      templateWrapper.classList.remove("no-results");
    }

  }

  render() {
    if(this.state.isRedirecting) return;

    const { merchandising, results, pagination } = this.props.store;
    const controller = this.props.controller;

    const context = getContext(['template']);

    let leftColumnLayout = ""

    if(window.Resources.searchspring.toolbar.leftColumnLayout == 'false') {
      leftColumnLayout = ""
    } else {
      leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    }

    
    return (
      context?.template === 'blog.magazine-issues' || context?.template === 'blog.magazine'? 
        <ResultsComponent
        className="page-width ss__mag-issues"
        controller={controller}
        results={results}
        />
      :
      <div class={(leftColumnLayout ? 'ss-results-left-column left-column-wrapper page-width' : 'ss-results')}>
        <Banner content={merchandising.content} type="header" />
        <Banner content={merchandising.content} type="banner" />

        <FeaturedFilter />

        { leftColumnLayout ? (
          <MediaQuery query="(min-width: 990px)">
            <div className="ss-results__top-wrapper page-width">
              <span class="left-hand">
               <h2 class="ss__filters-heading">Filters</h2>
                <ProductCount />
              </span>
              <Toolbar />
            </div>
          </MediaQuery>
        ) : (
          <MediaQuery query="(min-width: 990px)">
            <div className="ss-results__top-wrapper page-width">
              <ProductCount />
              <Toolbar />
            </div>
          </MediaQuery>
        )
        }

        { !leftColumnLayout ? (
          <MediaQuery query="(max-width: 989px)">
            <ProductCount />
            <Toolbar />
          </MediaQuery>
        ) : (null)
        }

        <MediaQuery query="(max-width: 989px)">
          <Toolbar />
          <ProductCount />
        </MediaQuery>


        <div class="clear"></div>

        <Profile name="results" controller={controller}>
          { leftColumnLayout ? (
            <SidebarContents leftColumnLayout={leftColumnLayout} />
          ): (
            null
          )}
          <ResultsComponent
            className="page-width"
            controller={controller}
            results={results}
          />
        </Profile>

        <div class="clear"></div>
      </div> 
    );
  }
}

@withController
@withStore
@observer
export class NoResults extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper')

    if (templateWrapper) {
        templateWrapper.classList.add('no-results')
        templateWrapper.classList.remove("some-results");
    }

    const searchPage = document.querySelector("#MainContent .seo-content-section"); 
    if(searchPage) {
      searchPage.style = "display: block";
    }
}

  render() {
    const store = this.props.store;
    return null;
  }
}
